import DashboardIcon from "./left-menu-icons/dashboard-icon.svg";
import LeadIcon from "./left-menu-icons/lead-management-icon.svg";
import CustomerIcon from "./left-menu-icons/customer-management-icon.svg";
import CampaignsIcon from "./left-menu-icons/campaigns-icon.svg";
import SurveysIcon from "./left-menu-icons/surveys-icon.svg";
import PaymentsIcon from "./left-menu-icons/payments-icon.svg";
import StatisticsIcon from "./left-menu-icons/statistics.-iconsvg.svg";
import PartnerIcon from "./left-menu-icons/partner-management-icon.svg";
import UserIcon from "./left-menu-icons/user-management-icon.svg";
import smilingProfileIcon from "./smiling-corporate-male.svg";
import profileIcon from "./avatar.svg";
import notificationIcon from "./notification.svg";
import settingsIcon from "./settings.svg";
import infoIcon from "./info.svg";
import logoutIcon from "./logout.svg";
import RoleSettingsIcon from "./left-menu-icons/role-setting-icon.svg";
import DeleteIcon from "./delete-outline.svg";
import AlertIcon from "./alert-icon.svg";
import EmailResendIcons from "./email-resend-link.svg";
import EmailResendIcon from "./email-resend-outline.svg";
import AlertInfoIcon from "./alert-info-icon.svg";
import ConfirmInfo from "./confirm-info.svg";
import Tick from "./tick.svg";
import GreenTick from "./green-tick.svg";
import DeleteRed from "./delete-red.svg";
import TermOfServicesInfo from "./terms-of-service-info.svg";
import PriceInfo from "./price-info.svg";
import ContactUsStars from "./contact-us-starts.svg";
import ContactUsLike from "./contact-us-like.svg";
import ExpandDownArrow from "./export-down-arrow.svg";
import ExpandUpArrow from "./export-up-arrow.svg";
import ExpandDown from "./expand-down-carat.png";
import ExpandUp from "./expand-up-carat.png";
import AFPLogo from "./afp-logo.svg";
import LeadReportInfo from "./lead-report-info.svg";
import TrailEmptyIcon from "./trail-no-data.svg";
import AttachmentIcon from "./attachment-icon.svg";

//lead-management
import LeadDetails from "./left-menu-icons/lead-management/lead-details-icon.svg";
import LeadAssignment from "./left-menu-icons/lead-management/lead-assignment-icon.svg";
import LeadCapture from "./left-menu-icons/lead-management/lead-capture-icon.svg";
import LeadQualification from "./left-menu-icons/lead-management/lead-qualification-icon.svg";
import LeadReports from "./left-menu-icons/lead-management/lead-reports-icon.svg";
import LeadLogs from "./left-menu-icons/lead-management/leadsLog.svg";
import AssignedLeads from "./left-menu-icons/lead-management/assigned-leads.svg";

//Customer-Engagement
import Profile from "./left-menu-icons/customer-engagement/customer-profile-icon.svg";
import CustomerEngagement from "./left-menu-icons/customer-engagement/customer-engagement-icon.svg";
import CustomerSupport from "./left-menu-icons/customer-engagement/customer-support-icon.svg";

//Campaigns
import CreateCampaignIcon from "./left-menu-icons/campaigns/create-campaigns.svg";
import ViewCampaignIcon from "./left-menu-icons/campaigns/view-campaigns-icon.svg";
import MetricsCampaignIcon from "./left-menu-icons/campaigns/campaigns-metrics-icon.svg";
import LandingPageIcon from "./left-menu-icons/campaigns/landing-page.svg";
import HubspotMenuIcon from "./left-menu-icons/campaigns/hubspot-icon.svg";

//Payments
import PaymentIcon from "./left-menu-icons/payments/payments-icon.svg";
import OrderIcon from "./left-menu-icons/payments/order-management-icon.svg";
import SubscriptionReportIcons from "./SubscriptionReportIcons.svg";

//Partner-management
import CrmPlansIcon from "./left-menu-icons/partner-management/crm-plans.svg";
import PartnerListIcon from "./left-menu-icons/partner-management/partner-list-icon.svg";
import RequestsIcon from "./left-menu-icons/partner-management/requests-icon.svg";
import ArrowRightIcon from "./arrow-right.svg";
import FilterIcon from "./filter-icon.svg";
import QrCodeIcon from './qr-code.svg';

//Email And Letter Templates
import EmailTemplateIcon from "./email-template-icon.svg"
import LetterTemplateIcon from "./letter-template-icon.svg"

import TrackUploadsIcon from './TrackUploadsIcon.svg'
import guidesIcon from './left-menu-icons/guidesIcons.svg';
import notesListIcon from './notes-list-icon.svg';
import AICallMonitoringIcon from "./left-menu-icons/ai-monitoring.svg";

const icons = {
  DashboardIcon,
  LeadIcon,
  CustomerIcon,
  CampaignsIcon,
  SurveysIcon,
  PaymentsIcon,
  StatisticsIcon,
  PartnerIcon,
  UserIcon,
  profileIcon,
  notificationIcon,
  settingsIcon,
  infoIcon,
  logoutIcon,
  RoleSettingsIcon,
  DeleteIcon,
  AlertIcon,
  EmailResendIcon,
  AlertInfoIcon,
  EmailResendIcons,
  ConfirmInfo,
  Tick,
  GreenTick,
  DeleteRed,
  TermOfServicesInfo,
  PriceInfo,
  ContactUsStars,
  ContactUsLike,
  ExpandDownArrow,
  ExpandUpArrow,
  ExpandDown,
  ExpandUp,
  AFPLogo,
  LeadReportInfo,
  AttachmentIcon,
  smilingProfileIcon,
  QrCodeIcon,

  //lead-management
  LeadDetails,
  LeadAssignment,
  LeadCapture,
  LeadQualification,
  LeadReports,
  LeadLogs,
  AssignedLeads,
  TrailEmptyIcon,

  //Customer-Engagement
  Profile,
  CustomerEngagement,
  CustomerSupport,

  //Campaigns
  CreateCampaignIcon,
  ViewCampaignIcon,
  MetricsCampaignIcon,
  LandingPageIcon,
  HubspotMenuIcon,

  //Payments
  PaymentIcon,
  OrderIcon,
  SubscriptionReportIcons,

  //Partner-management
  CrmPlansIcon,
  PartnerListIcon,
  RequestsIcon,
  ArrowRightIcon,
  FilterIcon,

  //Email And Letter Templates
  EmailTemplateIcon,
  LetterTemplateIcon,

  TrackUploadsIcon,
  guidesIcon,
  notesListIcon,
  AICallMonitoringIcon
};

export default icons;
